import * as React from "react";
import { TemplateComponentProps } from "experience-template-renderer-react";
import { useLocalization } from "@shared-ui/localization-context";
import { ErrorBoundary } from "components/errorBoundaries/errorBoundaries";

export const ExperienceTemplateComponentWrapper: React.FC<TemplateComponentProps> = (props) => {
  const { templateComponent, children } = props;
  const l10n = useLocalization();

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { l10n });
    }
    return child;
  });

  if (childrenWithProps?.length && childrenWithProps?.length > 0) {
    return <ErrorBoundary key={templateComponent.metadata?.id}>{childrenWithProps}</ErrorBoundary>;
  }

  return null;
};

export default ExperienceTemplateComponentWrapper;
